import React, { useState } from 'react';
import { Input, FormGroup, Button, Label, Col, Row } from 'reactstrap';

const SingleNextRound = ({ candidate, closeModal }) => {
  // Initialize state with candidate details and form fields
  const [formData, setFormData] = useState({
    candidateId: candidate?.candidateId || 'N/A',
    candidateName: `${candidate?.generalInfoCandidateDto?.firstName || ''} ${
      candidate?.generalInfoCandidateDto?.lastName || ''
    }`.trim() || 'N/A',
    jobTitle: candidate?.job?.[0]?.jobTitle || 'N/A',
    source: candidate?.othersDto?.source || 'N/A',
    applicationId: candidate?.applicationId || 'N/A',
    appliedOn: candidate?.appliedDate || 'DD/MM/YYYY',
    round: '',
    interviewer: '',
    interviewMode: 'virtual',
    virtualInterviewSource: '',
    virtualInterviewUrl: '', // New field for the URL
    location: '',
    interviewDate: '',
    interviewTime: '',
    sendRejectionEmail: false,
    doNotNotify: false,
  });

  // Handle changes for select inputs and text inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle changes for checkboxes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  // Handle form submission
  const handleSubmit = () => {
    // Prepare the data to send to the backend
    const submissionData = {
      candidateId: formData.candidateId,
      candidateName: formData.candidateName,
      jobTitle: formData.jobTitle,
      source: formData.source,
      applicationId: formData.applicationId,
      appliedOn: formData.appliedOn,
      round: formData.round,
      interviewer: formData.interviewer,
      interviewMode: formData.interviewMode,
      virtualInterviewSource:
        formData.interviewMode === 'virtual' ? formData.virtualInterviewSource : undefined,
      virtualInterviewUrl:
        formData.interviewMode === 'virtual' ? formData.virtualInterviewUrl : undefined, // Include URL
      location: formData.interviewMode === 'physical' ? formData.location : undefined,
      interviewDate: formData.interviewDate,
      interviewTime: formData.interviewTime,
      sendRejectionEmail: formData.sendRejectionEmail,
      doNotNotify: formData.doNotNotify,
    };

    // Log the submission data (replace with API call)
    console.log('Form Submission Data:', submissionData);

    // Example: Send data to backend
    // try {
    //   await post(api.MOVE_TO_NEXT_ROUND, submissionData);
    //   closeModal();
    // } catch (error) {
    //   console.error('Error submitting form:', error);
    // }

    // Close the modal after submission
    closeModal();
  };

  return (
    <div
      style={{
        minWidth: '640px',
        borderRadius: '32px',
        backgroundColor: '#fff',
        boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
        padding: '32px',
      }}
    >
      <p
        className="heading"
        style={{
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '28px',
          marginBottom: '24px',
        }}
      >
        Move to Next Round
      </p>
      <Row className="p-3 m-0 mt-1 data">
        <Col size={6}>
          <p className="info-head">Candidate ID</p>
          <p className="info">{formData.candidateId}</p>
          <p className="info-head">Job Title</p>
          <p className="info">{formData.jobTitle}</p>
          <p className="info-head">Source</p>
          <p className="info">{formData.source}</p>
        </Col>
        <Col size={6}>
          <p className="info-head">Candidate Name</p>
          <p className="info">{formData.candidateName}</p>
          <p className="info-head">Application ID</p>
          <p className="info">{formData.applicationId}</p>
          <p className="info-head">Applied On</p>
          <p className="info">{formData.appliedOn}</p>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col>
          <FormGroup>
            <Label
              style={{
                color: '#344054',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
              }}
            >
              Round
            </Label>
            <Input
              type="select"
              name="round"
              value={formData.round}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="screening">Screening Round</option>
              {/* <option value="technical">Technical Round</option>
              <option value="hr">HR Round</option> */}
              {/* Add more options as needed */}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label
              style={{
                color: '#344054',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
              }}
            >
              Interviewer(s)
            </Label>
            <Input
              type="select"
              name="interviewer"
              value={formData.interviewer}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
              <option value="interviewer1">Interviewer 1</option>
              <option value="interviewer2">Interviewer 2</option>
              {/* Add more options dynamically if needed */}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label
              style={{
                color: '#344054',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
              }}
            >
              Mode of Interview
            </Label>
            <Input
              type="select"
              name="interviewMode"
              value={formData.interviewMode}
              onChange={handleInputChange}
            >
              <option value="virtual">Virtual</option>
              <option value="physical">Physical/In-person</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
      {formData.interviewMode === 'virtual' ? (
        <>
          <Row>
            <Col>
              <FormGroup>
                <Label
                  style={{
                    color: '#344054',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                  }}
                >
                  Virtual Interview Source
                </Label>
                <Input
                  type="select"
                  name="virtualInterviewSource"
                  value={formData.virtualInterviewSource}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="zoom">Zoom</option>
                  <option value="google-meet">Google Meet</option>
                  <option value="teams">Microsoft Teams</option>
                </Input>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label
                  style={{
                    color: '#344054',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                  }}
                >
                  Virtual Interview URL
                </Label>
                <Input
                  type="text"
                  name="virtualInterviewUrl"
                  value={formData.virtualInterviewUrl}
                  onChange={handleInputChange}
                  placeholder="Enter meeting URL (e.g., https://zoom.us/j/123456789)"
                />
              </FormGroup>
            </Col>
          </Row>
        </>
      ) : (
        <Row>
          <Col>
            <FormGroup>
              <Label
                style={{
                  color: '#344054',
                  fontWeight: 500,
                  fontSize: '14px',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                }}
              >
                Location
              </Label>
              <Input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                placeholder="Location"
              />
            </FormGroup>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <FormGroup>
            <Label
              style={{
                color: '#344054',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0%',
              }}
            >
              Interview Date
            </Label>
            <Row>
              <Col>
                <Input
                  type="date"
                  name="interviewDate"
                  value={formData.interviewDate}
                  onChange={handleInputChange}
                  placeholder="DD-MM-YYYY"
                />
              </Col>
              <Col>
                <Input
                  type="time"
                  name="interviewTime"
                  value={formData.interviewTime}
                  onChange={handleInputChange}
                  placeholder="HH:MM"
                />
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              className="checkbox"
              type="checkbox"
              name="sendRejectionEmail"
              checked={formData.sendRejectionEmail}
              onChange={handleCheckboxChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Send  email to candidate
            </Label>
          </FormGroup>
          <FormGroup className="d-flex gap-2 align-items-center">
            <Input
              className="checkbox"  
              type="checkbox"
              name="doNotNotify"
              checked={formData.doNotNotify}
              onChange={handleCheckboxChange}
              style={{ border: '1px solid #475467' }}
            />
            <Label
              style={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '22px',
              }}
            >
              Notify Interviewer
            </Label>
          </FormGroup>
        </Col>
      </Row>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
        <Button
          onClick={closeModal}
          style={{
            backgroundColor: 'white',
            color: '#006438',
            border: '1px solid #006438',
            borderRadius: '12px',
            marginRight: '16px',
            width: '128px',
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          style={{
            backgroundColor: '#006438',
            color: '#FFFFFF',
            borderRadius: '12px',
            width: '128px',
          }}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default SingleNextRound;